/* M'OUD v6 · Verhalten und Messung (Spezifikation v1, Teil 20, 23; Messplan 21.10.2026).
   Ein Kaufweg: eine Zeile, frischer Warenkorb, Kasse. Jede Handlung, die etwas über
   das Verhalten sagt, wird gemessen. Sprache de/en nach MOUD.lang (21.10.2026). */
(function () {
  var C = window.MOUD || {}, d = document, w = window, b = d.body;
  var API = C.api || '';
  var EN = C.lang === 'en';
  b.classList.add('js');

  /* Sprache und Vorschau: interne Links bleiben in der Sprache der Seite und, solange das
     Theme nur in der Vorschau läuft, in der Vorschau. */
  var ROOT = (w.Shopify && Shopify.routes && Shopify.routes.root) || C.root || '/';
  var PREVIEW = w.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' ? String(Shopify.theme.id || '') : '';
  function local(href) {
    if (!href || href.charAt(0) !== '/' || href.charAt(1) === '/') return href;
    if (/^\/(cdn|checkout|cart\/|account|services)/.test(href)) return href;
    var r = ROOT.replace(/\/$/, '');
    if (r && href.indexOf(r + '/') !== 0 && href !== r) href = r + href;
    if (PREVIEW && href.indexOf('preview_theme_id=') < 0) {
      var i = href.indexOf('#'), hash = i > -1 ? href.slice(i) : '';
      if (i > -1) href = href.slice(0, i);
      href += (href.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + PREVIEW + hash;
    }
    return href;
  }
  d.querySelectorAll('a[href^="/"]').forEach(function (a) { a.setAttribute('href', local(a.getAttribute('href'))); });
  w.moudLocal = local;

  /* Sitzung und Herkunft */
  function rid() { return Math.random().toString(36).slice(2, 10) + Date.now().toString(36); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  var sid = ss('moud_sid'); if (!sid) { sid = rid(); ss('moud_sid', sid); }
  var qs = new URLSearchParams(location.search);
  var ext = d.referrer && d.referrer.indexOf(location.host) < 0 ? d.referrer : '';
  var refHost = ''; try { refHost = ext ? new URL(ext).hostname.replace(/^www\./, '') : ''; } catch (e) {}
  var src = qs.get('src') || qs.get('utm_source') || '';
  if (src || refHost) ss('moud_src', src || refHost);
  var sSrc = ss('moud_src') || 'direct';
  var ft = {}; try { ft = JSON.parse(ls('moud_ft') || '{}') || {}; } catch (e) { ft = {}; }
  if (!ft.s) { ft = { s: sSrc, c: qs.get('utm_campaign') || '', t: Date.now() }; ls('moud_ft', JSON.stringify(ft)); }
  var dev = w.matchMedia('(min-width:1025px)').matches ? 'desktop' : (w.matchMedia('(min-width:641px)').matches ? 'tablet' : 'mobile');
  var page = ((C.t || '') + (C.h ? ':' + C.h : '')).slice(0, 60);
  var t0 = Date.now();

  function track(ev, detail, value) {
    try {
      var body = {
        event_name: ev, session_id: sid, page: page, lang: C.lang || 'de', device: dev, version: PREVIEW ? 'v6-preview' : 'v6',
        market: C.cc || '', first_source: ft.s || '',
        detail: detail ? String(detail).slice(0, 120) : undefined,
        value: typeof value === 'number' && isFinite(value) ? value : undefined,
        utm_source: sSrc, utm_medium: qs.get('utm_medium') || undefined,
        utm_campaign: qs.get('utm_campaign') || undefined, utm_content: qs.get('utm_content') || undefined,
        referrer: ext ? ext.slice(0, 200) : undefined
      };
      if (API) fetch(API + 'trackLandingEvent', { method: 'POST', keepalive: true, headers: { 'content-type': 'text/plain' }, body: JSON.stringify(body) }).catch(function () {});
      if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('moud_' + ev, { detail: detail || '', value: value || 0, page: page });
    } catch (e) {}
  }
  w.moudTrack = track;

  track('page_view', C.t);
  if (C.t === 'product' && C.h) track('product_view', C.h, C.price);

  /* Scrolltiefe 25/50/75/100, einmal je Seite */
  var depths = [25, 50, 75, 100], sent = {};
  function depth() {
    var h = d.documentElement.scrollHeight - w.innerHeight; if (h <= 0) return;
    var p = Math.round(w.scrollY / h * 100);
    depths.forEach(function (x) { if (p >= x && !sent[x]) { sent[x] = 1; track('scroll_depth', String(x), x); } });
  }

  /* Verweildauer beim Verlassen */
  var exited = false;
  function exit() { if (exited) return; exited = true; track('page_exit', Object.keys(sent).join(',') || '0', Math.round((Date.now() - t0) / 1000)); }
  w.addEventListener('pagehide', exit);
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') exit(); });

  /* Abschnitte gesehen + Einblenden (Teil 2.4) */
  var io = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (el.classList.contains('reveal')) el.classList.add('in');
      if (el.dataset.sec && !el.dataset.seen) { el.dataset.seen = 1; track('section_view', el.dataset.sec); }
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -40px 0px' }) : null;
  d.querySelectorAll('.reveal,[data-sec]').forEach(function (el) { if (io) io.observe(el); else el.classList.add('in'); });

  /* Kopf (Teil 20.1): transparent über dem Held, Creme danach, beim Runterscrollen weg */
  var hd = d.getElementById('hd'), heroPage = hd && hd.dataset.hero === 'true', lastY = 0;
  var stickyEl = d.querySelector('.sticky'), mainBuy = d.getElementById('mainbuy'), stickySeen = false;
  function onScroll() {
    var y = w.scrollY;
    if (hd) {
      var heroEl = d.querySelector('.hero,.pmedia');
      var hh = heroPage && heroEl ? heroEl.getBoundingClientRect().bottom + y : 0;
      hd.classList.toggle('solid', !heroPage || y > hh - 64);
      if (Math.abs(y - lastY) > 8) { hd.classList.toggle('hide', y > lastY && y > 120); lastY = y; }
    }
    if (stickyEl && mainBuy) {
      var on = mainBuy.getBoundingClientRect().bottom < 56;
      stickyEl.classList.toggle('on', on); b.classList.toggle('has-sticky', on);
      if (on && !stickySeen) { stickySeen = true; track('sticky_shown', C.h); }
    }
    depth();
  }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', onScroll);
  onScroll();

  /* Hinweis oben */
  var toastEl = d.getElementById('toast'), tt;
  function toast(t) { if (!toastEl) return; toastEl.textContent = t; toastEl.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('on'); }, 2200); }

  /* Nummern je Duft (Teil 10.5), aus dem House */
  var NR = {};
  function paintNumbers() {
    Object.keys(NR).forEach(function (h) {
      var n = NR[h];
      d.querySelectorAll('[data-nr="' + h + '"]').forEach(function (el) { if (n.next) el.textContent = 'Nº ' + n.next + ' · '; });
      d.querySelectorAll('[data-nrbig="' + h + '"]').forEach(function (el) { el.textContent = n.next ? 'Nº ' + n.next : 'Nº'; });
      d.querySelectorAll('[data-nrtile="' + h + '"]').forEach(function (el) { el.textContent = n.next ? 'Nº ' + n.next + (EN ? ' available' : ' frei') : (EN ? 'Tranche 1 allocated' : 'Tranche 1 vergeben'); });
      d.querySelectorAll('[data-open="' + h + '"]').forEach(function (el) { el.textContent = n.next ? (EN ? n.open + ' of ' + n.size + ' open' : n.open + ' von ' + n.size + ' offen') : (EN ? 'allocated' : 'vergeben'); });
    });
  }
  if (API && d.querySelector('[data-nr],[data-nrbig],[data-nrtile],[data-open]')) {
    fetch(API + 'v6Numbers', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify({ action: 'next' }) })
      .then(function (r) { return r.json(); }).then(function (j) { if (j && j.numbers) { NR = j.numbers; paintNumbers(); } }).catch(function () {});
  }

  /* Kaufen: eine Zeile, frischer Warenkorb, Kasse (Teil 1, 23.5) */
  function post(url, data) { return fetch(url, { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify(data || {}) }); }
  function buy(bt) {
    var h = bt.dataset.handle, where = bt.dataset.where || '', reserve = bt.dataset.reserve === '1';
    bt.classList.add('wait');
    track('cta_click', (reserve ? 'reserve:' : 'buy:') + h + ':' + where, +bt.dataset.price || undefined);
    var nr = null;
    var pre = reserve && API ? fetch(API + 'v6Numbers', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify({ action: 'reserve', handle: h }) })
      .then(function (r) { return r.json(); }).then(function (j) { if (j && j.number) nr = j.number; }).catch(function () {}) : Promise.resolve();
    pre.then(function () { return post(ROOT + 'cart/clear.js'); })
      .then(function () { var it = { id: +bt.dataset.buy, quantity: 1 }; if (nr) it.properties = { 'Nº': String(nr) }; return post(ROOT + 'cart/add.js', { items: [it] }); })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return post(ROOT + 'cart/update.js', { attributes: { _moud_sid: sid, _moud_src: sSrc, _moud_first: ft.s || '', _moud_where: where, _moud_v: PREVIEW ? 'v6-preview' : 'v6' } }); })
      .then(function () {
        track('checkout_start', h + (nr ? ':' + nr : '') + ':' + where, +bt.dataset.price || undefined);
        location.href = ROOT + 'checkout';
      })
      .catch(function (err) {
        bt.classList.remove('wait');
        track('checkout_failed', h + ':' + (err && err.message || ''));
        toast(EN ? 'The checkout is not responding. Please try again.' : 'Die Kasse antwortet nicht. Bitte noch einmal.');
      });
  }
  w.addEventListener('pageshow', function (e) { if (e.persisted) d.querySelectorAll('.btn.wait').forEach(function (x) { x.classList.remove('wait'); }); });

  /* Ein Klick-Verteiler für alles, was gemessen wird */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var bt = t.closest('[data-buy]');
    if (bt) { e.preventDefault(); if (!bt.disabled && !bt.classList.contains('wait')) buy(bt); return; }
    var sz = t.closest('[data-size]');
    if (sz) {
      var pd = sz.closest('[data-pd]'); if (pd) { pd.dataset.mode = sz.dataset.size; pd.querySelectorAll('[data-size]').forEach(function (x) { x.classList.toggle('on', x.dataset.size === sz.dataset.size); }); }
      d.querySelectorAll('.sticky').forEach(function (s) { s.dataset.mode = sz.dataset.size; });
      if (sz.dataset.top) w.scrollTo({ top: 0, behavior: 'smooth' });
      track('cta_secondary', 'size:' + sz.dataset.size + ':' + (C.h || ''));
      return;
    }
    var th = t.closest('[data-thumb]');
    if (th) { var im = d.getElementById('pimg'); if (im) { im.src = th.dataset.thumb; im.removeAttribute('srcset'); } th.parentNode.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === th); }); track('cta_secondary', 'thumb:' + (C.h || '')); return; }
    if (t.closest('[data-sheet]')) { var sh = d.getElementById('sheet'); if (sh) sh.hidden = false; track('cta_secondary', 'sheet_open'); return; }
    if (t.closest('[data-close]')) { var sh2 = d.getElementById('sheet'); if (sh2) sh2.hidden = true; return; }
    var lg = t.closest('[data-lang]');
    if (lg) { track('lang_switch', 'lang:' + lg.getAttribute('data-lang')); return; }
    var sm = t.closest('summary');
    if (sm) { track('faq_open', sm.textContent.trim().slice(0, 100)); return; }
    var a = t.closest('a[href]');
    if (a) {
      var href = a.getAttribute('href') || '';
      var where = a.dataset.where || (a.closest('[data-sec]') ? a.closest('[data-sec]').dataset.sec : '');
      if (href.indexOf('wa.me') > -1) track('whatsapp_click', where || 'button');
      else if (/instagram\.com/.test(href)) track('instagram_click', where);
      else if (/^https?:/.test(href) && href.indexOf(location.host) < 0) track('outbound_click', href.replace(/^https?:\/\//, '').slice(0, 80));
      else track('cta_secondary', 'link:' + href.replace(/[?&]preview_theme_id=\d+/, '').slice(0, 60) + (where ? ':' + where : ''));
    }
  });

  var lf = d.getElementById('locform');
  if (lf) lf.addEventListener('submit', function (e) { var v = e.submitter && e.submitter.value || (lf.country_code && lf.country_code.value) || ''; track('lang_switch', v); });

  d.querySelectorAll('video').forEach(function (v) { v.addEventListener('play', function () { track('video_play', C.h || C.t); }, { once: true }); });

  /* Stimmen aus dem House: nur freigegebene (listPublicReviews) */
  d.querySelectorAll('[data-reviews]').forEach(function (box) {
    if (!API) return;
    var h = box.dataset.reviews, lim = +box.dataset.limit || 3;
    var q = { can_publish: true }; if (h) q.product_handle = h;
    fetch(API + 'listPublicReviews', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify(q) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var rows = Array.isArray(j) ? j : (j && Array.isArray(j.data) ? j.data : (j && Array.isArray(j.reviews) ? j.reviews : []));
        rows.slice(0, lim).forEach(function (r) {
          var txt = (r.one_liner || r.content || r.review_text || r.text || '').trim(); if (!txt) return;
          var row = d.createElement('div'); row.className = 'r';
          var thb = d.createElement('div'); thb.className = 'th';
          if (r.photo_url) { var im = d.createElement('img'); im.src = r.photo_url; im.alt = ''; im.loading = 'lazy'; thb.appendChild(im); }
          var tx = d.createElement('div'); var p = d.createElement('p'); p.className = 'q'; p.textContent = (EN ? '“' : '«') + txt.slice(0, 220) + (EN ? '”' : '»');
          var s = d.createElement('small'); s.textContent = [(r.reviewer_name || '').trim(), (r.product_title || '').split(' — ')[0].replace(/^Oud Amal$/, 'Oud Amal Intense')].filter(Boolean).join(' · ');
          tx.appendChild(p); tx.appendChild(s); row.appendChild(thb); row.appendChild(tx); box.appendChild(row);
        });
      }).catch(function () {});
  });
})();